import { hasCornerCore } from "./index22.js";
import { ArrangeInARow } from "./index128.js";
import { ResizeToFill } from "./index129.js";
import { AggNmcsRules } from "./index164.js";
import { Nmcs } from "./index165.js";
import { BoneSide, EntryLocation, RG_TYPE } from "@project-rouge/rg-core";
import { CopyAcrossFloors, MuscleToVector, RgShallowClone } from "@project-rouge/rg-three";
import seedrandom from "seedrandom";
const AggUnitsOnMuscleNMCS = ({ dataset, muscle, distribution, weights, endClosingDistances, endEntranceDistances }) => {
	const { gap, f2fHeight } = dataset.aggConfig;
	const sequence = CalculateUnits({
		dataset,
		muscle,
		distribution,
		weights,
		endClosingDistances,
		endEntranceDistances
	});
	if (sequence.length === 0) return {
		flatsAndCores: [],
		onGFChildren: []
	};
	const cores = sequence.filter((u) => u.type === RG_TYPE.Core);
	if (cores.length > 0) {
		if (muscle.flip) cores.reverse();
		if (!muscle.bone.joints.some((j) => j.bones.length > 1)) cores.shift();
		for (let i = 0; i < cores.length; i++) cores[i].data.hasExit = true;
	}
	const onGFChildren = sequence.slice().map(RgShallowClone);
	if (!(onGFChildren.filter((c) => c.type === RG_TYPE.Core).length === 0) && muscle.lockEnds[0] && muscle.lockEnds[1]) ResizeToFill({
		row: onGFChildren,
		space: MuscleToVector(muscle).length(),
		rgType: RG_TYPE.Core,
		gap
	});
	const aboveGFChildren = onGFChildren.slice().map(RgShallowClone);
	if (muscle.entry) {
		const entranceIndices = [];
		for (let i = 0; i < aboveGFChildren.length; i++) if (aboveGFChildren[i].type === RG_TYPE.Entrance) {
			entranceIndices.push(i);
			aboveGFChildren.splice(i, 2, RgShallowClone(dataset.apartments.aboveEntrance[0]));
		}
	}
	ArrangeInARow({
		row: onGFChildren,
		rot: 180,
		z: 0,
		gap
	});
	ArrangeInARow({
		row: aboveGFChildren,
		rot: 180,
		z: 0,
		gap
	});
	const everyAboveGFChildren = CopyAcrossFloors({
		list: aboveGFChildren.map(RgShallowClone),
		floors: muscle.bone.floors - 1,
		height: f2fHeight,
		yStart: f2fHeight
	});
	const flatsAndCores = onGFChildren.concat(everyAboveGFChildren);
	for (const obj of flatsAndCores) if (obj.type === RG_TYPE.Apartment || obj.type === RG_TYPE.Core || obj.type === RG_TYPE.Entrance) obj.data.muscleID = muscle.id;
	muscle.realLength = onGFChildren.reduce((sum$1, a) => sum$1 + a.size[0] + gap, 0) - gap;
	return {
		flatsAndCores,
		onGFChildren
	};
};
function CalculateUnits({ dataset, muscle, distribution, weights, endClosingDistances, endEntranceDistances }) {
	const startJoint = muscle.side === BoneSide.Right ? muscle.bone.joints[0] : muscle.bone.joints[1];
	const endJoint = muscle.side === BoneSide.Right ? muscle.bone.joints[1] : muscle.bone.joints[0];
	const hasCornerAt = [startJoint.bones.length > 1, endJoint.bones.length > 1];
	const distToCore = [hasCornerCore(startJoint) ? 0 : 30, hasCornerCore(endJoint) ? 0 : 30];
	const nmcs = new Nmcs(new AggNmcsRules({
		dataset,
		targetLength: MuscleToVector(muscle).length(),
		lockEnds: muscle.lockEnds,
		targetUnitMix: distribution,
		skipCores: muscle.skipCores,
		canCloseEnds: muscle.canCloseEnds,
		maxCorridorDists: muscle.corridorDist,
		targetEntranceCount: muscle.entry ? 1 : 0,
		hasEntryAtStart: muscle.entry === EntryLocation.Start,
		hasCornerAt,
		distToCore,
		targetFireCoreCount: muscle.fireCores ?? 0,
		targetLiftCoreCount: muscle.liftCores ?? 0,
		targetStairCoreCount: muscle.stairCores ?? 0,
		endClosingDistances,
		endEntranceDistances,
		weights
	}));
	const rng = seedrandom("1");
	const { solution, reward } = nmcs.runSearch({
		level: 2,
		rng
	});
	if (-reward >= 1e6) return [];
	return solution.sequence.map((u) => u.unit);
}
export { AggUnitsOnMuscleNMCS };

//# sourceMappingURL=index166.js.map